import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { isBaseQueryError } from '~/lib/types/api/isQueryError';
import { ChakraText } from '@equip.health/ui';

type ErrorData = {
  message?: string;
};

type Props = {
  error?: FetchBaseQueryError | SerializedError;
};
export const PatientNoteItemErrorMessage = ({ error }: Props) => {
  if (!error || !isBaseQueryError(error)) {
    return <></>;
  }
  const errorData = error.data as ErrorData;
  return (
    <>
      {error && isBaseQueryError(error) && (
        <ChakraText
          color="red.500"
          fontSize="12px"
          marginBottom="24px"
          textAlign="right"
          width="100%"
        >
          {errorData.message
            ? errorData.message.toString()
            : 'An unexpected error occurred'}
        </ChakraText>
      )}
    </>
  );
};
